import React from 'react';
import { motion } from 'framer-motion';

function Terms() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="min-h-screen bg-gray-50 py-12"
    >
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-3xl font-bold mb-6">Kullanım Koşulları</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-6">
              Son güncelleme tarihi: {new Date().toLocaleDateString('tr-TR')}
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Hizmet Kullanım Şartları</h2>
            <p>
              Excel Vadisi'ni kullanarak aşağıdaki koşulları kabul etmiş sayılırsınız. 
              Bu koşulları kabul etmiyorsanız, lütfen sitemizi kullanmayınız.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Üyelik</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Hesap Oluşturma:</strong> Doğru ve güncel bilgiler sağlamakla yükümlüsünüz.
              </li>
              <li>
                <strong>Hesap Güvenliği:</strong> Hesap güvenliğinizden siz sorumlusunuz.
              </li>
              <li>
                <strong>Yaş Sınırı:</strong> Hizmetlerimizi kullanmak için 18 yaşından büyük olmalısınız.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Kullanıcı İçeriği</h2>
            <p>
              Platformumuzda paylaştığınız tüm içeriklerden siz sorumlusunuz. Paylaşılan içerikler:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Yasalara uygun olmalıdır</li>
              <li>Başkalarının haklarını ihlal etmemelidir</li>
              <li>Spam veya zararlı içerik barındırmamalıdır</li>
              <li>Telif haklarına saygılı olmalıdır</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Fikri Mülkiyet Hakları</h2>
            <p>
              Excel Vadisi'nde yer alan tüm içerik, tasarım, logo ve materyaller şirketimizin 
              fikri mülkiyetidir. Bu içeriklerin izinsiz kullanımı, kopyalanması ve dağıtılması yasaktır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Hizmet Değişiklikleri</h2>
            <p>
              Excel Vadisi, sunduğu hizmetlerde değişiklik yapma, hizmetleri askıya alma veya 
              sonlandırma hakkını saklı tutar. Bu değişiklikler öncesinde kullanıcılar bilgilendirilir.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Sorumluluk Reddi</h2>
            <p>
              Excel Vadisi, platformda yer alan içeriklerin doğruluğu, güncelliği ve kullanımından 
              doğabilecek zararlardan sorumlu değildir. Kullanıcılar, platformu kendi sorumluluklarında kullanır.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Hesap İptali</h2>
            <p>
              Excel Vadisi, kullanım koşullarını ihlal eden hesapları askıya alma veya 
              kalıcı olarak kapatma hakkını saklı tutar.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. İletişim</h2>
            <p>
              Kullanım koşulları hakkında sorularınız için{' '}
              <a 
                href="https://www.instagram.com/excelvbamakro/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:text-blue-800 inline-flex items-center"
              >
                Instagram hesabımız
                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                  <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                </svg>
              </a>{' '}
              üzerinden bizimle iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Terms;